<div
  class="flex h-full flex-col px-md shadow-1 delay-200 ease-in-out"
  style="transition: width 750ms cubic-bezier(0.4, 0, 0.2, 1)"
  [class.w-56]="open"
  [class.initial-width]="!open"
  (transitionstart)="animationStart()"
  (transitionend)="animationEnd()"
>
  <div class="mt-md mr-md flex flex-row-reverse" style="transition: margin-right 750ms cubic-bezier(0.4, 0, 0.2, 1)">
    <fa-icon
      class="cursor-pointer"
      style="transition: transform 750ms cubic-bezier(0.4, 0, 0.2, 1)"
      [ngClass]="{'rotate-180': !open}"
      [icon]="openIcon"
      (click)="toggleOpen()"
    ></fa-icon>
  </div>
  <div class="flex h-full flex-col justify-between">
    <nav class="mt-2xl">
      <ng-content select="cft-sidenav-items[placement='main']"></ng-content>
    </nav>
    <nav class="mb-2xl">
      <ng-content select="cft-sidenav-items[placement='secondary']"></ng-content>
    </nav>
  </div>
</div>
